__turbopack_context__.v({
  "cardSmall": "CardGroupCarousel-module-scss-module__UqHKMG__cardSmall",
  "carousel": "CardGroupCarousel-module-scss-module__UqHKMG__carousel",
  "centered": "CardGroupCarousel-module-scss-module__UqHKMG__centered",
  "fade-in": "CardGroupCarousel-module-scss-module__UqHKMG__fade-in",
  "holiday": "CardGroupCarousel-module-scss-module__UqHKMG__holiday",
  "inlineIntro": "CardGroupCarousel-module-scss-module__UqHKMG__inlineIntro",
  "inner": "CardGroupCarousel-module-scss-module__UqHKMG__inner",
  "item": "CardGroupCarousel-module-scss-module__UqHKMG__item",
  "products": "CardGroupCarousel-module-scss-module__UqHKMG__products",
  "recipeProducts": "CardGroupCarousel-module-scss-module__UqHKMG__recipeProducts",
  "recipes": "CardGroupCarousel-module-scss-module__UqHKMG__recipes",
  "root": "CardGroupCarousel-module-scss-module__UqHKMG__root",
  "slide": "CardGroupCarousel-module-scss-module__UqHKMG__slide",
  "threeUpContained": "CardGroupCarousel-module-scss-module__UqHKMG__threeUpContained",
  "threeUpFull": "CardGroupCarousel-module-scss-module__UqHKMG__threeUpFull",
});
